 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		48: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		48: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors","1":"layouts__AuthLayout","2":"layouts__BlankLayout","3":"layouts__CaLayout","4":"layouts__LandingLayout","5":"layouts__OdLayout","6":"layouts__TranslationLayout","7":"layouts__UserLayout","8":"p__403","9":"p__404","10":"p__500","11":"p__ca__cart","12":"p__ca__cart__model.ts","13":"p__ca__deals__list__model.ts","14":"p__ca__deals__view__model.ts","15":"p__ca__dishes__list__model.ts","16":"p__ca__dishes__view__model.ts","17":"p__ca__events__list__model.ts","18":"p__ca__events__view__model.ts","19":"p__ca__group__model.ts","20":"p__ca__home__model.ts","21":"p__ca__menus__list__model.ts","22":"p__ca__menus__view__model.ts","23":"p__ca__order__invoice__model.ts","24":"p__ca__order__payment__model.ts","25":"p__ca__order__process__model.ts","26":"p__ca__previous-order","27":"p__ca__previous-order__model.ts","28":"p__ca__restaurant-details__model.ts","29":"p__landing__model.ts","30":"p__od__dashboard__model.ts","31":"p__od__management__dishes__edit__model.ts","32":"p__od__management__dishes__view__model.ts","33":"p__od__management__menus__edit__model.ts","34":"p__od__management__menus__view__model.ts","35":"p__od__orders__invoice__model.ts","36":"p__od__settings__business__model.ts","37":"p__user__claim__model.ts","38":"p__user__contact__model.ts","39":"p__user__forget__model.ts","40":"p__user__login__model.ts","41":"p__user__package__checkout__model.ts","42":"p__user__package__pay__model.ts","43":"p__user__package__subscription__model.ts","44":"p__user__register__model.ts","45":"p__user__sso__model.ts","46":"p__welcome__ca","47":"p__welcome__ca__model.ts","49":"viz"}[chunkId]||chunkId) + "." + {"0":"210de3d2","1":"0c179ed7","2":"afaa84d5","3":"3e72d8ac","4":"4333e2a4","5":"0f8dca50","6":"20c7bb95","7":"e1768ef3","8":"0ae86e82","9":"87de1e78","10":"a4caabb7","11":"13d467ec","12":"c9d99be9","13":"adc1e500","14":"002d1bfc","15":"192eeba7","16":"69b3d8fd","17":"29e40d5b","18":"0c0bd8f5","19":"221e0a14","20":"3e6428da","21":"3edb82cf","22":"1e6f49ca","23":"34d45e7e","24":"7e6c0437","25":"19bf2f05","26":"ecc9f5b9","27":"0587b26d","28":"f9227eb5","29":"00bf3fe1","30":"43ddf03e","31":"2b5f4674","32":"d840e9ff","33":"c1c5f887","34":"728ab614","35":"b63a09ba","36":"8e1a6c32","37":"533287bf","38":"84fa087c","39":"6718f376","40":"19cd98d0","41":"9adf3491","42":"9ddc8b6e","43":"a2f451bd","44":"c1c8e0f1","45":"cfac2964","46":"82bb2e10","47":"19bea2d4","49":"2da5b982"}[chunkId] + ".async.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"3":1,"4":1,"5":1,"7":1,"11":1,"26":1,"46":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors","1":"layouts__AuthLayout","2":"layouts__BlankLayout","3":"layouts__CaLayout","4":"layouts__LandingLayout","5":"layouts__OdLayout","6":"layouts__TranslationLayout","7":"layouts__UserLayout","8":"p__403","9":"p__404","10":"p__500","11":"p__ca__cart","12":"p__ca__cart__model.ts","13":"p__ca__deals__list__model.ts","14":"p__ca__deals__view__model.ts","15":"p__ca__dishes__list__model.ts","16":"p__ca__dishes__view__model.ts","17":"p__ca__events__list__model.ts","18":"p__ca__events__view__model.ts","19":"p__ca__group__model.ts","20":"p__ca__home__model.ts","21":"p__ca__menus__list__model.ts","22":"p__ca__menus__view__model.ts","23":"p__ca__order__invoice__model.ts","24":"p__ca__order__payment__model.ts","25":"p__ca__order__process__model.ts","26":"p__ca__previous-order","27":"p__ca__previous-order__model.ts","28":"p__ca__restaurant-details__model.ts","29":"p__landing__model.ts","30":"p__od__dashboard__model.ts","31":"p__od__management__dishes__edit__model.ts","32":"p__od__management__dishes__view__model.ts","33":"p__od__management__menus__edit__model.ts","34":"p__od__management__menus__view__model.ts","35":"p__od__orders__invoice__model.ts","36":"p__od__settings__business__model.ts","37":"p__user__claim__model.ts","38":"p__user__contact__model.ts","39":"p__user__forget__model.ts","40":"p__user__login__model.ts","41":"p__user__package__checkout__model.ts","42":"p__user__package__pay__model.ts","43":"p__user__package__subscription__model.ts","44":"p__user__register__model.ts","45":"p__user__sso__model.ts","46":"p__welcome__ca","47":"p__welcome__ca__model.ts","49":"viz"}[chunkId]||chunkId) + "." + {"0":"c51ed5f1","1":"31d6cfe0","2":"31d6cfe0","3":"1b78efa5","4":"8259692b","5":"92d38d91","6":"31d6cfe0","7":"d9042fba","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"03fccf31","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"b8924498","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"aef88500","47":"31d6cfe0","49":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1);
